const InputText = ({ id, type, label, value, onChange, required = false }) => (
  <div className="mb-6">
    <input
      type={type}
      id={id}
      name={id}
      placeholder={label}
      value={value}
      onChange={onChange}
      className="p-5 bg-white border border-slate-200 text-gray-900 text-sm rounded-lg hover:bg-primary-light active:bg-primary-light  block w-full   transition-all duration-300"
      required={required}
    />
  </div>
);

export default InputText;
